import { Container } from '../../../../../types/container';
import { CustomFieldValue } from '../../../../../types/custom_field';
import { PdfFieldEntity } from '../PdfDataKey';
import { PdfEntityDataResolver } from '../PdfEntityDataResolver';

export enum PdfContainerProperty {
  identifier = 'identifier',
}

export class PdfContainerDataResolver extends PdfEntityDataResolver<Container, PdfContainerProperty> {
  properties = Object.values(PdfContainerProperty);
  entityType = PdfFieldEntity.container;

  getCustomFieldByEntity(entity: Container, id: string): CustomFieldValue | undefined {
    return entity.customFields.get(id);
  }

  getLabelByProperty(property: PdfContainerProperty): string {
    switch (property) {
      case PdfContainerProperty.identifier:
        return 'Container Identifier';
    }
  }

  getValueByProperty(property: PdfContainerProperty, entity: Container): string {
    switch (property) {
      case PdfContainerProperty.identifier:
        return entity.identifier;
    }
  }
}
